import { db } from '../firebase-config';
import { collection, doc, writeBatch, getDocs, query, where } from 'firebase/firestore';

export const createCompanyWithSlots = async (selectedCompany) => {
    if (!selectedCompany) {
        throw new Error("Invalid company data");
    }

    const batch = writeBatch(db);
    const slotsQuery = query(
        collection(db, 'slots'),
        where('company', '==', selectedCompany)
    );

    const slotSnapshot = await getDocs(slotsQuery);

        
    if (slotSnapshot.empty) {
        for (let i = 1; i <= 21; i++) {
            const slotRef = doc(collection(db, 'slots'), `slot${i}_${selectedCompany}`);
            batch.set(slotRef, {
                slotNumber: i,
                company: selectedCompany,
                companyId: selectedCompany.id || null
            });
        }
        await batch.commit();
    } else {
        console.log("Slots already exist for ", selectedCompany);
    }
};